import { render } from "./TheSearchResultMain.vue?vue&type=template&id=115bfa18&scoped=true&ts=true"
import script from "./TheSearchResultMain.vue?vue&type=script&lang=ts"
export * from "./TheSearchResultMain.vue?vue&type=script&lang=ts"

import "./TheSearchResultMain.vue?vue&type=style&index=0&id=115bfa18&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115bfa18"]])

export default __exports__